import React from "react";
import { useLocation } from "react-router-dom";
import LiveChat from "./Pages/LiveChat/LiveChat";

const ConditionalLiveChat = () => {
  const location = useLocation();

  const hideLiveChatPaths = [
    "/login",
    "/signup",
    "/auth/verify/otp",
    "/account",
    "/account/verify-email",
    "/account/reset-password",
    "/account/password-reset",
    "/account/reset-confirmation",
    "/account/email-verified",
    "/account/change-password",
    "/account/email-verification",
  ];

  const hideLiveChat = hideLiveChatPaths.includes(location.pathname);

  return !hideLiveChat ? <LiveChat /> : null;
};

export default ConditionalLiveChat;
